<script>
import { dailyGameCopy } from '../utils/dailyGameCopy'
export default {
  name: 'DailyGameCondition',
  props: { game: { type: String, required: true }, eligibility: { type: Object, default: null }, config: { type: [Object, Array], default: null } },
  computed: { copy () { return dailyGameCopy(this.eligibility, this.config, this.game) } }
}
</script>
<template>
  <div class="daily-game-condition"><p class="daily-game-rule">{{ copy.rule }}</p><p v-if="copy.description" class="daily-game-description">{{ copy.description }}</p><small>รับสิทธิ์ได้วันละ 1 ครั้ง · เริ่มวันใหม่เวลา 00:00 น. ไทย</small></div>
</template>
<style scoped>
.daily-game-condition{padding:18px 16px;text-align:center;line-height:1.7;color:inherit}.daily-game-rule{font-weight:700;margin:0}.daily-game-description{white-space:pre-wrap;overflow-wrap:anywhere;margin:8px 0}.daily-game-condition small{display:block;margin-top:8px;opacity:.75}
</style>
